import * as angular from "angular";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";
import { DialogUtils } from "../../helper/dialog.helper";
import { Limit } from "../../models/limit.model";
import { Plan } from "../../models/plan.model";
import { PermissionCheck } from "../../shared/permission";

let PlanDetailsCardComponent = {
    selector: "vcPlanDetailsCard",
    templateUrl: "/angular/components/profile/plan-details-card.component.html",
    bindings: {
        campaign: "=",
    },
    controller: class PlanDetailsCardController {
        // * bindings for typescript compiler *
        public campaign: any;
        // ************************************

        private $scope: any;
        private dialog: DialogUtils;
        private defaultDialogs: DefaultDialogs;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private limitDataProvider: LimitDataProvider;
        private $location: any;
        private $window: any;

        public __env: any;
        public permissionProvider: PermissionCheck;
        public nextPayment: string;
        public loadingNextPayment: boolean;
        public planLoading: boolean;
        public limits: Limit;
        public plan: Plan | null;
        public nextInvoice: any;
        public appType: string;
        public isOrgCampaign: boolean;

        constructor(
            $scope: any,
            __env: any,
            $location: any,
            $window: any,
            DialogUtils: DialogUtils,
            DefaultDialogs: DefaultDialogs,
            PermissionCheck: PermissionCheck,
            SubscriptionDataProvider: SubscriptionDataProvider,
            LimitDataProvider: LimitDataProvider,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.defaultDialogs = DefaultDialogs;
            this.__env = __env;
            this.$location = $location;
            this.$window = $window;
            this.permissionProvider = PermissionCheck;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.limitDataProvider = LimitDataProvider;
            this.appType = __app_type;
            this.loadingNextPayment = true;

            if (this.permissionProvider.hasStripeSubscription) {
                SubscriptionDataProvider.invoices().then((json: any) => {
                    this.loadingNextPayment = false;
                    if (json.next_payment) {
                        this.nextPayment = json.next_payment;
                    }
                });
                SubscriptionDataProvider.upcomingInvoice().then((data: any) => {
                    this.nextInvoice = data;
                });
            }
        }

        $onInit() {
            this.isOrgCampaign =
                this.appType == "USER" &&
                this.campaign.isOrganisationCampaign();

            if (this.campaign.cpid) {
                this.planLoading = true;
                this.subscriptionDataProvider.planInfo(this.campaign.cpid).then(
                    (activePlan: object) => {
                        if (activePlan) {
                            this.plan = new Plan(activePlan);
                        }
                        this.planLoading = false;
                    },
                    () => {
                        this.plan = null;
                        this.planLoading = false;
                    }
                );
            } else {
                this.limitDataProvider.get().then((limits: Limit) => {
                    this.plan = new Plan({
                        cpname: "Custom",
                        cpmax: `${limits.houseoccupants}`,
                        userslimit: limits.totalUsersLimit,
                        superuserslimit: limits.totalSuperUsersLimit,
                        customfieldslimit: limits.totalCustomFieldsLimit,
                    });
                });
            }
        }

        openViewInvoices($event: any): void {
            this.dialog.show({
                component: "vc-view-invoice-dialog",
                targetEvent: $event,
                scope: this.$scope,
                locals: {
                    campaign: this.campaign,
                },
                ariaLabel: "View Invoice History",
                class: "profilecard",
                size: "x-large",
            });
        }
        openPromoCodeDialog(event: any): void {
            this.dialog
                .show({
                    component: "vc-promo-code-dialog",
                    targetEvent: event,
                    size: "large",
                    scope: this.$scope,
                    locals: {},
                })
                .then(() => {
                    this.$window.location.reload();
                });
        }
        openViewPlanDialog(ev: any): void {
            this.$location.url("/accountdetails");
        }

        openChangePlanDialog(ev: any): void {
            if (this.permissionProvider.hasStripeSubscription) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: "change",
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.defaultDialogs.contactSupport(
                    "Upgrade subscription",
                    "creating additional accounts",
                    ev
                );
            }
        }
    },
};

angular
    .module("profile")
    .component(PlanDetailsCardComponent.selector, PlanDetailsCardComponent);
